import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../css/Navbar.css";


function resolveAsset(name) {
  try {
    const req = require.context("../", true, /\.(svg|png|jpe?g)$/);
    const match = req
      .keys()
      .find((k) => k.toLowerCase().includes(name.toLowerCase()));
    if (match) {
      const res = req(match);
      return res.default || res;
    }
  } catch (e) {
    // ignore
  }
  return `${process.env.PUBLIC_URL || ""}/${name}`;
}

const logoSvg = resolveAsset("logo.svg");

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    closeMobileMenu();

    const scrollToContact = () => {
      const el = document.getElementById("contact-us");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    if (location.pathname === "/") {
      scrollToContact();
    } else {
      navigate("/");
      setTimeout(scrollToContact, 150);
    }
  };

  return (
    <nav className="navbar-wrapper">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" onClick={closeMobileMenu}>
          <div className="navbar-logo-circle">
            <img
              src={logoSvg}
              alt="OSSCE Logo"
              className="navbar-logo-img"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
          <div className="navbar-brand-text">
            <span className="navbar-brand-name">OSSCE</span>
            <span className="navbar-brand-subtitle">
              Oxford Society for Science Communication and Engagement
            </span>
          </div>
        </Link>

        {/* Desktop Links */}
        <div className="navbar-links">
          <Link to="/" className="navbar-link">
            Home
          </Link>
          <Link to="/about" className="navbar-link">
            About Us
          </Link>
          <Link to="/program" className="navbar-link">
            Programme
          </Link>
          <Link to="/news" className="navbar-link">
            News
          </Link>
          <a
            href="/#contact-us"
            onClick={handleContactClick}
            className="navbar-link"
          >
            Contact Us
          </a>

          <div className="navbar-social-links">
            <a
              href="https://www.linkedin.com/company/ossce/"
              className="navbar-social-link"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect x="2" y="9" width="4" height="12" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/oxscicom/"
              className="navbar-social-link"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
          </div>
        </div>

        {/* Mobile Hamburger Button */}
        <button
          className="navbar-hamburger"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Drawer */}
      {mobileMenuOpen && (
        <div className="navbar-mobile-drawer">
          <Link to="/" className="navbar-link" onClick={closeMobileMenu}>
            Home
          </Link>
          <Link to="/about" className="navbar-link" onClick={closeMobileMenu}>
            About Us
          </Link>
          <Link to="/program" className="navbar-link" onClick={closeMobileMenu}>
            Programme
          </Link>
          <Link to="/news" className="navbar-link" onClick={closeMobileMenu}>
            News
          </Link>
          <a
            href="/#contact-us"
            onClick={handleContactClick}
            className="navbar-link"
          >
            Contact Us
          </a>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
